import Config from "../db/config";
import { isSafari } from "../utils/apple";
import { getDeviceId } from "../utils/device";

export class ConfigHelper {
    static async getWorkerVersion() {
        let version = "";
        try {
            version = (await Config.get(Config.KEYS.WORKER_VERSION)).value;
        } catch (e) {
            //do nothing
        }
        return version;
    }

    static async setWorkerVersion(version = "") {
        return Config.add(Config.KEYS.WORKER_VERSION, version);
    }

    static async getToken() {
        let token = "";
        try {
            token = (await Config.get(isSafari() ? Config.KEYS.APNS_TOKEN : Config.KEYS.FCM_TOKEN)).value;
        } catch (e) {
            //do nothing here
        }
        return token;
    }

    static async _saveToken(token) {
        return Config.add(isSafari() ? Config.KEYS.APNS_TOKEN : Config.KEYS.FCM_TOKEN, token);
    }

    static async hasUserAgreePush() {
        let result = false;
        try {
            result = (await Config.get(Config.KEYS.USER_CHOICE)).value || false;
            console.log(`User already agreed push: ${result}`);
        } catch (e) {
            console.log(`User already agreed push: ${e.message}`);
        }
        return result;
    }

    /**
     * return if the subscribe popup is already shown
     * default false
     * @returns
     */
    static async isSubscribePopupShown() {
        let result = false;
        try {
            result = (await Config.get(Config.KEYS.SUBSCRIBE_POPUP_SHOWN)).value || false;
            console.log(`Device already shown subscribe popup: ${result}`);
        } catch (e) {
            console.log("Device wants show subscribe popup");
        }
        return result;
    }

    /**
     * store that subscribe popup is shown
     * and also store user choice
     */
    static async storeSubscribePopup(userChoice) {
        try {
            await Config.add(Config.KEYS.SUBSCRIBE_POPUP_SHOWN, true);
        } catch (e) {
            console.log(e.message);
        }
        console.log(`Store user permission choice: ${userChoice}`);
        try {
            await Config.add(Config.KEYS.USER_CHOICE, userChoice);
        } catch (e) {
            console.log(e.message);
        }
    }

    /**
     * @returns stored deviceId or initialize a new value
     */
    static async getDeviceId() {
        let deviceId = "";
        try {
            deviceId = (await Config.get(Config.KEYS.DEVICE_ID)).value;
        } catch (e) {
            console.log("New device, we need a new id");
        }
        if (!deviceId) {
            deviceId = getDeviceId();
            await ConfigHelper.setDeviceId(deviceId);
        }
        console.log(`Device ID: ${deviceId}`);

        return deviceId;
    }

    static async setDeviceId(deviceId) {
        if (!deviceId) {
            throw new Error("deviceId must be set");
        }
        return Config.add(Config.KEYS.DEVICE_ID, deviceId);
    }

    static async deleteToken() {
        try {
            await Config.del(isSafari() ? Config.KEYS.APNS_TOKEN : Config.KEYS.FCM_TOKEN);
        } catch (e) {
            console.log(e.message);
        }
    }

    static async updateToken(newToken) {
        const token = await ConfigHelper.getToken();
        if (token !== newToken) {
            console.log(`Stored token: ${token}`);
            try {
                await ConfigHelper._saveToken(newToken);
            } catch (e) {
                console.warn(e.message);
            }
        }
    }

    static async saveApp(packageName, config) {
        try {
            console.log(`Store app: ${packageName}`);
            await Config.add(Config.KEYS.PACKAGE_NAME, packageName);
            await Config.add(packageName, config);
        } catch (e) {
            console.log(e.message);
        }
    }

    static async getApp() {
        const packageName = (await Config.get(Config.KEYS.PACKAGE_NAME)).value;
        console.log(`Get app: ${packageName}`);
        return { ...(await Config.get(packageName)).value, packageName };
    }

    static async saveDeviceRegistration(registration = {}) {
        try {
            await Config.add(Config.KEYS.DEVICE_REGISTRATION_STATUS, registration);
        } catch (e) {
            console.log(e.message);
        }
    }

    static async getDeviceRegistration() {
        try {
            return (await Config.get(Config.KEYS.DEVICE_REGISTRATION_STATUS)).value || {};
        } catch (e) {
            return {};
        }
    }

    static async clearAll() {
        return Config.clear();
    }
}
